const translations = {
    message: 'Subscribe to AcreConnect to unlock all features.',
    subscribeNow: 'Subscribe Now!'
};

export default translations;
